import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography
} from '@material-ui/core'

const useStyles = makeStyles({
    root: {
        maxWidth: 250,
    },
    media: {
        height: 100,
    },
})


const BudgetCardapio = (props) => {

    const classes = useStyles()

    const mocados = {

    }
    
    const alertar = () => {
        
    }


    return (
        <Card className={classes.root}>
            <CardActionArea>
                <CardMedia
                    className={classes.media}
                    //image="/static/images/cards/contemplative-reptile.jpg"
                    image="https://www.google.com.br/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png"
                    title={props.titleImg}
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {props.title}
          </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {props.price}
          </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary" onClick={alertar}>
                    Inserir
                </Button>
            </CardActions>
        </Card>
    )
}

export default BudgetCardapio